
    export default {
      mounted() {
        // The server owns the zone -> country mapping; this hook only
        // reports the device time zone (where the user's device is set).
        this.pushEvent("country_time_zone", { zone: this.timeZone() });
      },

      timeZone() {
        try {
          return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
        } catch {
          return "";
        }
      }
    }
  